/**
 * One slate match (specs/home-page AC-9): kits, "Home v Away", kickoff, and one chip per pick.
 */

import React from 'react';
import { View, Text } from 'react-native';
import { TeamCrest } from '../../competitions/TeamCrest/TeamCrest';
import { formatMatchKickoff } from '../../../src/home/helpers/homeCountdown.helper';
import { HOME_TEST_IDS } from '../../../src/home/constants/home.constants';
import type { SlateMatchView } from '../../../src/home/types/home.types';
import { SLATE_CREST_SIZE, type TodayChallengeCardStyles } from './TodayChallengeCard.styles';

export interface SlateMatchRowProps {
  match: SlateMatchView;
  /** Matches after the first get a divider above them. */
  isFirst: boolean;
  styles: TodayChallengeCardStyles;
}

export const SlateMatchRow: React.FC<SlateMatchRowProps> = ({ match, isFirst, styles }) => (
  <View style={[styles.match, !isFirst && styles.matchDivider]} testID={`${HOME_TEST_IDS.slateMatch}-${match.matchId}`}>
    <View style={styles.matchHeader}>
      <View style={styles.crests}>
        <TeamCrest teamName={match.home.name} kit={match.home.kit} size={SLATE_CREST_SIZE} />
        <View style={styles.crestOverlap}>
          <TeamCrest teamName={match.away.name} kit={match.away.kit} size={SLATE_CREST_SIZE} />
        </View>
      </View>
      <Text style={styles.teams} numberOfLines={1}>
        {match.home.name}
        <Text style={styles.vs}> v </Text>
        {match.away.name}
      </Text>
      <Text style={styles.kickoff}>{formatMatchKickoff(match.kickoff)}</Text>
    </View>
    <View style={styles.chips}>
      {match.picks.map((pick) => (
        <View
          key={`${match.matchId}-${pick.marketId}`}
          style={styles.chip}
          testID={`${HOME_TEST_IDS.slatePick}-${match.matchId}-${pick.marketId}`}
        >
          <Text style={styles.chipLabel}>{pick.label}</Text>
          <Text style={styles.chipValue}>{pick.display}</Text>
        </View>
      ))}
    </View>
  </View>
);
